import type { HubActivityDto, HubEvent } from '@aiai/shared';

/** Newest tool call per run, from the live /hub socket, keyed by runId. */
export type LiveActivity = Record<string, HubActivityDto>;
export const LIVE_ACTIVITY_MAX = 200;

/** The newer (by `at`) of a snapshot activity and a live one; live wins a tie. */
export function newerActivity(snapshot?: HubActivityDto | null, live?: HubActivityDto | null): HubActivityDto | null {
  if (!snapshot || !live) return snapshot ?? live ?? null;
  return Date.parse(live.at) >= Date.parse(snapshot.at) ? live : snapshot;
}

/** Folds one live hub event into the map; returns `prev` (same reference) when nothing changes. */
export function applyHubEvent(prev: LiveActivity, e: HubEvent): LiveActivity {
  if (e.type === 'run.line' && e.kind === 'tool_use' && e.runId && e.tool) {
    // Re-insert so the touched run is newest; the oldest keys fall off the front.
    const { [e.runId]: _old, ...rest } = prev;
    const next: LiveActivity = { ...rest, [e.runId]: { tool: e.tool, detail: e.detail ?? null, at: e.at } };
    const keys = Object.keys(next);
    for (const k of keys.slice(0, Math.max(0, keys.length - LIVE_ACTIVITY_MAX))) delete next[k];
    return next;
  }
  if (e.type === 'run.settled' && e.runId && e.runId in prev) {
    const { [e.runId]: _gone, ...rest } = prev;
    return rest;
  }
  return prev;
}
